import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import { withStyles } from "@material-ui/core/styles";
import withWidth from "@material-ui/core/withWidth";
import Typography from "@material-ui/core/Typography";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Divider from "@material-ui/core/Divider";
import Button from "@material-ui/core/Button";
import ButtonGroup from "@material-ui/core/ButtonGroup";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";

import ListItem from "@material-ui/core/ListItem";
import { LinearProgress, ListItemText } from "@material-ui/core";
import CardActions from "@material-ui/core/CardActions";
import Grid from "@material-ui/core/Grid";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import {unlockAllStudents} from "../firebaseApi"; 

const styles = (theme) => ({
  appBarSpacer: theme.mixins.toolbar,
  topBar: {
    top: 0,
    zIndex: 2,
  },
  bottomBar: {
    top: "auto",
    bottom: 0,
  },
  pollActions: {
    padding: 0,
    width: 550,
  },
  pollActionsControls: {
    padding: 0,
    width: 550,
    top: -40,
  },
  listItemLeft: {
    display: "flex",
    justifyContent: "flex-start",
  },
  listItemLeftHidden: {
    display: "flex",
    justifyContent: "flex-start",
    marginLeft: "auto", // Move elements to the left
  },
});

function InstructorTopBar(props) {
  let mobile = props.width === "sm" || props.width === "xs";
  const [timerInterval, setTimerInterval] = React.useState(null);
  const [timer, setTimer] = React.useState(0);
  const [anonymousPollColor, setAnonymousPollColor] = React.useState(false);
  const [buttonPressTimer, setButtonPressTimer] = React.useState(null);
  const [loadingSession, setLoadingSession] = React.useState(false);
  const [loadingPoll, setLoadingPoll] = React.useState(false);

  const handleLongPress = () => {
    // This function will handle the long-press action (right-click equivalent)
    if (!props.pollLive) {
      const anonPoll = true;
      props.newPoll(anonPoll);
    } else {
      props.deactivatePoll();
    }
  };

  const handleTouchStart = () => {
    // Start the long press timer (500ms for example)
    setButtonPressTimer(setTimeout(handleLongPress, 500));
  };

  const handleTouchEnd = () => {
    // If the user releases the touch before 500ms, cancel the long press
    if (buttonPressTimer) {
      clearTimeout(buttonPressTimer);
      setButtonPressTimer(null);
    }
  };

  React.useEffect(() => {
    setLoadingSession(false);
  }, [props.sessionNumber]);

  React.useEffect(() => {
    setLoadingPoll(false);
  }, [props.pollLive, props.pollShowDisplay]);

  // Function to make background of top bar a different color when poll is anonymous
  React.useEffect(() => {
    if (props.pollLive && props.pollAnonymous) {
      setAnonymousPollColor(true);
    } else {
      setAnonymousPollColor(false);
    }
  }, [props.pollLive, props.pollAnonymous]);

  function updateTimer() {
    setTimer((prev) => {
      return prev + 1;
    });
  }

  function pad(s, n, p) {
    let ss = String(s);
    for (let i = 0; i < n; i++) {
      if (ss.length < n) {
        ss = p + ss;
        return ss;
      }
    }
    return ss;
  }

  function fmtTime() {
    let s = timer % 60;
    let m = Math.floor(timer / 60);
    return `${pad(m, 2, "0")}:${pad(s, 2, "0")}`;
  }
  /* eslint-disable react-hooks/exhaustive-deps */
  React.useEffect(() => {
    if (props.pollLive) {
      let s = Math.floor((Date.now() - props.pollStartTime) / 1000);
      setTimer(s);
      const interval = setInterval(updateTimer, 1000);
      setTimerInterval(interval);
    } else {
      if (timerInterval !== null) {
        clearInterval(timerInterval);
        setTimerInterval(null);
      }
      setTimer(0);
    }
  }, [props.pollLive]);
  // eslint-disable-enable react-hooks/exhaustive-deps
  let secondAppBar = !props.sessionNumber ? null : (
    <ListItem
      className={
        props.showControls && mobile
          ? props.classes.pollActionsControls
          : props.classes.pollActions
      }
      dense={true}
    >
      {!props.showControls ? (
        <ListItemText
          primary={
            !props.pollNumber
              ? "No Poll is Active"
              : "Poll " +
                props.pollNumber +
                (timer > 0 ? ` is running (${fmtTime()})` : " is stopped")
          }
          secondary={"Session " + props.sessionNumber}
        />
      ) : null}
      <CardActions>
        {props.showControls ? (
          <Button
            onClick={() => {
              props.handleControls();
              props.stopScreenShare();
            }}
            startIcon={<HighlightOffIcon />}
          ></Button>
        ) : null}

        <Button
          size="small"
          variant={
            props.pollLive && props.pollAnonymous ? "outlined" : "contained"
          }
          style={{
            fontSize: "12px",
            userSelect: "none", // Disable text selection
            WebkitUserSelect: "none", // Disable text selection on iPhone/Safari
            MozUserSelect: "none", // For Firefox
          }}
          color={!props.pollLive ? "primary" : "secondary"}
          disabled={loadingPoll || loadingSession}
          onClick={() => {
            setLoadingPoll(true);
            if (!props.pollLive) {
              const anonPoll = false;
              props.newPoll(anonPoll);
            } else {
              props.deactivatePoll();
            }
          }}
          onContextMenu={(event) => {
            event.preventDefault();
            handleLongPress();
          }}
          onTouchStart={handleTouchStart}
          onTouchEnd={handleTouchEnd}
          onTouchMove={handleTouchEnd}
        >
          {!props.pollLive ? "Start Poll" : "Stop Poll " + props.pollNumber}
        </Button>

        <Button
          size="small"
          variant="contained"
          style={{
            fontSize: "12px",
          }}
          disabled={loadingPoll || loadingSession}
          color={!props.pollShowDisplay ? "primary" : "secondary"}
          onClick={() => {
            if (props.pollNumber > 0) {
              props.setShowDisplay(!props.pollShowDisplay);
              setLoadingPoll(true);
            }
          }}
        >
          {!props.pollShowDisplay ? "Show Results" : "Hide Results"}
        </Button>

        {props.showControls ? (
          <ListItemText
            primary={!props.pollNumber ? "" : timer > 0 ? `(${fmtTime()})` : ""}
            //secondary={"Session " + props.sessionNumber}
          />
        ) : null}
        {props.showControls ? (
          <ListItemText
            primary={!props.pollLive ? "0" : Object.keys(props.students).length}
          />
        ) : null}
      </CardActions>
    </ListItem>
  );

  return (
    <div>
      <AppBar
        className={props.classes.topBar}
        color="inherit"
        position="fixed"
        style={{
          backgroundColor:
            anonymousPollColor && props.showControls ? "gray" : "",
        }}
        elevation={0}
      >
        <Toolbar>
          <Grid
            container
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Grid item>
              <Grid container direction="row" alignItems="center">
                <Grid item>
                  {!props.showControls ? (
                    <IconButton
                      color="inherit"
                      onClick={() => {
                        props.userMenuOpenCtl(!props.userMenuOpen);
                      }}
                    >
                      <MenuIcon />
                    </IconButton>
                  ) : null}
                </Grid>

                {!props.showControls ? (
                  <Grid item>
                    <Typography display="inline" variant="h6">
                      {props.courseName ? props.courseName : "WebClicker"}
                    </Typography>
                  </Grid>
                ) : null}
              </Grid>
            </Grid>

            <Grid item>{mobile ? null : secondAppBar}</Grid>

            {!props.showControls ? (
              <Grid item>
                {!props.courseName ? null : (
                  <ButtonGroup size="small">
                    <Button
                      variant="contained"
                      color={!props.sessionNumber ? "primary" : "secondary"}
                      size="small"
                      onClick={() => {
                        setLoadingSession(true);
                        if (!props.sessionNumber) {
                          
                          props.setManualSessionStart();
                          props.startScreenShare();
                          props.newSession();
                        } else {
                          props.stopScreenShare();
                          props.deactivateSession();
                          // unlockAllStudents({courseID:props.course.courseID});
                          props.handleEndGeolocation();
                        }
                      }}
                      disabled={props.loadingLocation || loadingSession || loadingPoll}
                    >
                      {!props.sessionNumber
                        ? "New Session"
                        : "Stop Session " + props.sessionNumber}
                    </Button>

                    <Button
                      variant="outlined"
                      onClick={() => {
                        props.sessionMenuOpenCtl(!props.sessionMenuOpen);
                      }}
                    >
                      {!props.sessionNumber
                        ? "Sessions"
                        : "Session " + props.sessionNumber}
                    </Button>
                    <Button
                      variant="outlined"
                      color={!props.sessionNumber ? "primary" : ""}
                      disabled={
                        Boolean(props.sessionNumber) ||
                        !props.lastSessionAvailable ||
                        loadingSession
                      }
                      onClick={() => {
                        setLoadingSession(true);
                        props.setManualSessionStart();
                        props.startScreenShare();
                        props.resumeSession();
                      }}
                    >
                      Resume Last
                    </Button>
                  </ButtonGroup>
                )}
              </Grid>
            ) : null}
          </Grid>
        </Toolbar>

        {!mobile ? null : <Toolbar>{secondAppBar}</Toolbar>}

        {props.loading ? <LinearProgress /> : null}
        {props.sessionLoading ? <LinearProgress /> : null}
        <Divider />
      </AppBar>

      {!mobile ? null : <div className={props.classes.appBarSpacer} />}
    </div>
  );
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  withRouter(
    withStyles(styles, { withTheme: true })(withWidth()(InstructorTopBar))
  )
);
